export enum CryptoInvoiceStatus {
  CREATED = 'CREATED',
  REGISTERED = 'REGISTERED',
  PENDING = 'PENDING',
  PAID = 'PAID',
  EXPIRED = 'EXPIRED'
}
